import { 
    MessageResponseDto, 
    GetTransactionAddonDto, 
    CreateTransactionAddonDto, 
    EditTransactionAddonDto,
    TransactionAddonControllerGet200Response,
    TransactionAddonApiFp,
    DeleteTransactionAddonDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTransactionAddonModel = TransactionAddonControllerGet200Response;
export type GetTransactionAddonModel = GetTransactionAddonDto;
export type MutateResponseTransactionAddonModel = MessageResponseDto;
export type CreateTransactionAddonModel = CreateTransactionAddonDto;
export type UpdateTransactionAddonModel = EditTransactionAddonDto;
export type DeleteTransactionAddonModel = DeleteTransactionAddonDto;

export const apiTransactionAddonFp = TransactionAddonApiFp(apiConfig);
export const getTransactionAddonController = apiTransactionAddonFp.transactionAddonControllerGet;
export const createTransactionAddonController = apiTransactionAddonFp.transactionAddonControllerCreate;
export const updateTransactionAddonController = apiTransactionAddonFp.transactionAddonControllerEdit;
export const deleteTransactionAddonController = apiTransactionAddonFp.transactionAddonControllerDelete;

export const QueryKeyTransactionAddon = QueryKey.TransactionAddon;